export default [
  {
    path: '/',
    name: 'index',
    component: () => import('@/modules/Base/Index/index.vue'),
    meta: {
      title: 'Главная страница',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/modules/Base/Login.vue'),
    meta: {
      title: 'Вход',
      layout: 'empty',
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/modules/Base/Calendar/index.vue'),
    meta: {
      title: 'Календарь',
    },
  },
  {
    path: '/auth-code',
    name: 'auth-code',
    component: () => import('@/modules/Base/AuthCode.vue'),
    meta: { title: 'Вход по коду' },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/modules/Base/404.vue'),
    meta: {
      title: 'Страница не найдена',
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/modules/Base/403.vue'),
    meta: {
      title: 'Доступ запрещен',
    },
  },
  {
    path: '*',
    redirect: { name: '404' },
  },
];
